import { useSelector } from 'react-redux';
import { RootState } from '../../../../../redux/store';
import { Box } from '@mui/material';
import PersonIcon from '@mui/icons-material/Person';

import { LayoutModule } from '../../../../layout/modules';
import { useSubtypeDPDetail } from './hook';
import { SubtypeDPData } from './data';
import { SubtypeDPParamsHistorical } from '../historical';
import ActionButtonGroup from '../../../../components/general/buttons/actionButtonGroup';
import { isOnlyViewProfile } from '../../../../../shared/types/profiles';
import {
    SUBTYPE_DP_NEW,
    SUBTYPE_DP,
    SUBTYPE_DP_EDIT,
    SUBTYPE_DP_DETAIL,
} from '../../../../../routes/paths';
import { SubtypeDPRegisterHistory } from './registerHistory';

export const SubtypeDPDetail = () => {
    const {
        subtypeDP,
        subtypeDPHistorical,
        showHistorical,
        setShowHistorical,
    } = useSubtypeDPDetail();

    const { logUser } = useSelector((state: RootState) => state.general);
    const { type } = logUser || {};

    const toggleHistorical = () => {
        setShowHistorical(!showHistorical);
    };

    return (
        <>
            <LayoutModule
                title="Detalle Subtipo DP"
                withAccordion={false}
                additionalButtons={
                    <ActionButtonGroup
                        id={subtypeDP?.id || ''}
                        buttonCreate={{
                            show: !isOnlyViewProfile(type),
                            route: SUBTYPE_DP_NEW,
                        }}
                        buttonSearch={{
                            show: true,
                            route: SUBTYPE_DP,
                        }}
                        buttonUpdate={{
                            show: !isOnlyViewProfile(type),
                            route: SUBTYPE_DP_EDIT,
                        }}
                        buttonView={{
                            show: true,
                            route: SUBTYPE_DP_DETAIL,
                        }}
                        buttonLog={{
                            show: Boolean(subtypeDP?.id),
                        }}
                        onHistoricalShow={toggleHistorical}
                    />
                }
            >
                {showHistorical && (
                    <Box sx={{ marginTop: 2 }}>
                        <SubtypeDPParamsHistorical
                            historical={subtypeDPHistorical ?? []}
                            showHistorical={true}
                        />
                    </Box>
                )}
                <LayoutModule
                    title=""
                    showTitle={false}
                    titleChildren="Información general"
                    icon={<PersonIcon sx={{ color: 'primary.main' }} />}
                >
                    <SubtypeDPData data={subtypeDP} />
                </LayoutModule>
            </LayoutModule>
            <SubtypeDPRegisterHistory subtypeDP={subtypeDP} />
        </>
    );
};
